"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MolecularSequence_Repository = exports.MolecularSequence_RepositoryTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var MolecularSequence_RepositoryTypeKind;
(function (MolecularSequence_RepositoryTypeKind) {
    MolecularSequence_RepositoryTypeKind["_directlink"] = "directlink";
    MolecularSequence_RepositoryTypeKind["_openapi"] = "openapi";
    MolecularSequence_RepositoryTypeKind["_login"] = "login";
    MolecularSequence_RepositoryTypeKind["_oauth"] = "oauth";
    MolecularSequence_RepositoryTypeKind["_other"] = "other";
})(MolecularSequence_RepositoryTypeKind = exports.MolecularSequence_RepositoryTypeKind || (exports.MolecularSequence_RepositoryTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_MolecularSequence_Repository = t.recursion('IMolecularSequence_Repository', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: (0, EnumType_1.createEnumType)(MolecularSequence_RepositoryTypeKind, 'MolecularSequence_RepositoryTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        url: RTTI_uri_1.RTTI_uri,
        _url: RTTI_Element_1.RTTI_Element,
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        datasetId: t.string,
        _datasetId: RTTI_Element_1.RTTI_Element,
        variantsetId: t.string,
        _variantsetId: RTTI_Element_1.RTTI_Element,
        readsetId: t.string,
        _readsetId: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_MolecularSequence_Repository.js.map